// Ékezetek eltávolátása stringből
const normalizeString = (str: string | null | undefined) => (str || '').toLocaleLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
export default normalizeString